import React, { useEffect, useState } from "react";
import styled from "styled-components";
import * as Icon from "react-feather";
import { H5, P } from "../Texts";
import moment from "moment";
import { Badge, LinkButton } from "../Buttons";
import DeleteServiceModal from "../../organisms/DeleteServiceModal";
import { Link, useParams } from "react-router-dom";

const ServiceCardStyle = styled.div`
  border-radius: 4px;
`;

const DropDown = ({
  orgId,
  toggleDropDown,
  serviceId,
  toggleDeleteServiceModal,
}) => {
  const dropdownRef = React.useRef(null);

  const checkIfNotInDropDown = ({ target }) => {
    if (dropdownRef.current && !dropdownRef.current.contains(target)) {
      toggleDropDown();
    }
  };

  useEffect(() => {
    window.addEventListener("click", checkIfNotInDropDown);

    return () => {
      toggleDropDown();
      window.removeEventListener("click", checkIfNotInDropDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div
      ref={dropdownRef}
      className="bg-white shadow-md py-2 absolute top-4 right-0"
    >
      <Link to={`/dashboard/organization/${orgId}/programs/${serviceId}/details`}>
        <LinkButton
          color="#000000"
          className="whitespace-no-wrap mb-2 text-left hover:bg-blue-100 w-full"
          p="4px 40px 4px 20px"
        >
          View
        </LinkButton>
      </Link>
      <Link to={`/dashboard/organization/${orgId}/programs/${serviceId}/edit`}>
        <LinkButton
          color="#000000"
          className="whitespace-no-wrap mb-2 text-left hover:bg-blue-100 w-full"
          p="4px 40px 4px 20px"
        >
          Edit
        </LinkButton>
      </Link>
      <LinkButton
        color="#D73636"
        className="whitespace-no-wrap text-left hover:bg-blue-100 w-full"
        p="4px 40px 4px 20px"
        onClick={toggleDeleteServiceModal}
      >
        Delete
      </LinkButton>
    </div>
  );
};

export const ServiceCard = ({
  service: { name, createdAt, referrals = [], draft, id: serviceId },
  width,
  loading,
}) => {
  const { id: orgId } = useParams();
  const [showServiceDropDown, setShowServiceDropDown] = useState(false);
  const [showDeleteServiceModal, setShowDeleteServiceModal] = useState(false);

  const toggleDeleteServiceModal = () =>
    setShowDeleteServiceModal(!showDeleteServiceModal);
  const toggleServiceActionDropDown = () =>
    setShowServiceDropDown(!showServiceDropDown);

  return (
    <ServiceCardStyle width={width} className="bg-white p-5 shadow">
      <div className="flex justify-between">
        <H5
          color="#22202C"
          fontFamily="regular"
          fontSize="16px"
          smallSize="16px"
          className="mb-0 font-semibold line-clamp-2 flex-grow"
        >
          {name}
        </H5>
        <div className="relative">
          <Icon.MoreVertical
            color="#25282B"
            size={18}
            className="flex-shrink-0 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              toggleServiceActionDropDown();
            }}
          />

          {showServiceDropDown && (
            <DropDown
              orgId={orgId}
              serviceId={serviceId}
              toggleDropDown={toggleServiceActionDropDown}
              toggleDeleteServiceModal={toggleDeleteServiceModal}
            />
          )}
        </div>
      </div>
      <P color="#C4C4C4" fontSize="14px" smallSize="14px" className="mb-20 truncate">
        Posted on {moment(createdAt ?? new Date()).format("ll")}
      </P>
      <div className="flex justify-between items-center">
        <P
          color="#000000"
          fontSize="14px"
          smallSize="14px"
          className="my-0 truncate"
        >
          {referrals?.length || 0} referral received
        </P>
        <Badge bg="#393648" color="#FFFFFF" p="3px 8px" fontSize="12px">
          {!draft ? "PUBLISHED" : "DRAFT"}
        </Badge>
      </div>
      {showDeleteServiceModal && (
        <DeleteServiceModal
          closeModal={toggleDeleteServiceModal}
          deleting={loading}
          serviceId={serviceId}
        />
      )}
    </ServiceCardStyle>
  );
};
